export default [

    {
        path: '/tableau-de-board',
        name: 'dashboard',
        component: () =>
            import ('@/views/dashboard/DashBoard.vue'),
        meta: {
            requiresAuth: true,
            requiresAdminOrSuperAdmin: true,
        },
    },

    {
        path: '/user-stay-doing-objectives/:year',
        name: 'user-stay-doing-objectives',
        component: () =>
            import ('@/views/dashboard/UserStayDoingObjectif.vue'),
        meta: {
            requiresAuth: true,
            requiresAdminOrSuperAdmin: true,
            pageTitle: 'Tableau de Bord',
            breadcrumb: [
                {
                    text: 'Tableau de Bord',
                    to: '/tableau-de-board',
                },
                {
                    text: 'Objectifs non réalisés',
                    active: true,

                }
            ],
        },
    },
    {
        path: '/user-stay-doing-evaluation/:year',
        name: 'user-stay-doing-evaluation',
        component: () =>
            import ('@/views/dashboard/UserStayDoingEvaluation.vue'),
        meta: {
            requiresAuth: true,
            requiresAdminOrSuperAdmin: true,
            pageTitle: 'Tableau de Bord',
            breadcrumb: [
                {
                    text: 'Tableau de Bord',
                    to: '/tableau-de-board',
                },
                {
                    text: 'Auto-Evaluation / Evaluation non réalisés',
                    active: true,

                }
            ],
        },
    },
]


